var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: {
              title: _vm.$t("apps.inventory.message.storeage"),
              subtitle: _vm.$t("series.lot") + " " + _vm.lotCode
            }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.warehouse") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      options: _vm.optionWarehouses,
                      disabled: _vm.disabled || _vm.isEditPage
                    },
                    on: { change: _vm.handleChangeWarehouseId },
                    model: {
                      value: _vm.input.whId,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "whId", $$v)
                      },
                      expression: "input.whId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.bin") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      options: _vm.optionBinLocations,
                      disabled: _vm.disabled || _vm.isEditPage
                    },
                    model: {
                      value: _vm.input.binId,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "binId", $$v)
                      },
                      expression: "input.binId"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("message.orderlist") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  _vm.orderLot.isRenderOrder
                    ? _c("OrderLot", {
                        attrs: {
                          validation: _vm.orderLot.trickValidationOrder,
                          data: _vm.orderLot.orders,
                          createAble: false,
                          showProductImage: true,
                          selectedWhId: _vm.input.whId
                        },
                        on: { onChange: _vm.handleChangeOrder }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.date") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.inventory.label.datein") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: {
                      classNames: [
                        { "is-invalid": _vm.$v.input.dateIn.$error }
                      ],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.dateIn.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.dateIn, "$model", $$v)
                      },
                      expression: "$v.input.dateIn.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.dateproduct") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.dateProduct,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "dateProduct", $$v)
                      },
                      expression: "input.dateProduct"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.dateexpire") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.dateExpire,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "dateExpire", $$v)
                      },
                      expression: "input.dateExpire"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.note") }
                  }),
                  _vm._v(" "),
                  _c("BaseTextArea", {
                    attrs: { disabled: _vm.disabled, rows: 3 },
                    model: {
                      value: _vm.input.note,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "note", $$v)
                      },
                      expression: "input.note"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4bb5c62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bb5c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/ImsLotNumberForm.vue
// module id = null
// module chunks = 